import React, { useState } from "react";

import PendingApprovals from "./PendingApprovals";
const PendingApprovalsMainComponent = ({}) => {
  return (
    <div className="pt-[83px] max-w-[1440px] m-auto md:px-6 px-4">
    {" "}
    <PendingApprovals />
  </div>
  );
};

export default PendingApprovalsMainComponent;